<template>
  <td
  >
    {{ recipe.name }}
  </td>
  <td
  >
    <div class="input-group-sm">
      <input
        type="number"
        v-model.number="v$.recipe.quantity_system.$model"
        inputmode="decimal"
        class="form-control shadow-none text-end"
        style="font-size: 12px;"
        :placeholder="$t('Enter system quantity') + '...'"
      >
      <div v-for="error of v$.recipe.quantity_system.$errors"
        class="d-block invalid-feedback"
        :key="error.$uid"
      >
        {{ error.$message }}
      </div>
    </div>
  </td>
  <td
    class="text-end"
  >
    <div class="input-group-sm">
      <input
        type="number"
        v-model.number="v$.recipe.quantity_display.$model"
        inputmode="decimal"
        class="form-control shadow-none text-end"
        style="font-size: 12px;"
        :placeholder="$t('Enter display quantity') + '...'"
      >
      <div v-for="error of v$.recipe.quantity_display.$errors"
        class="d-block invalid-feedback"
        :key="error.$uid"
      >
        {{ error.$message }}
      </div>
    </div>
  </td>
  <td
  >
    {{ recipe.unit_name ? $t(recipe.unit_name) : '' }}
  </td>
  <td
  >
    {{ formatNumberTwoDigit(totalCost) }}
  </td>
  <td
  >
    <select2
      v-model.trim="v$.recipe.condition.$model"
      @select="onSelectedUnit"
      :options="select2ConditionOptions"
      :settings="{
        minimumResultsForSearch: Infinity,
      }"
      :disabled="$parent.type === 'EDIT'"
    />
    <div v-for="error of v$.recipe.condition.$errors"
      class="d-block invalid-feedback"
      :key="error.$uid"
    >
      {{ error.$message }}
    </div>
  </td>
  <td
    class="align-content-center text-end"
  >
    <button
      type="button"
      style="font-size: 9px;"
      class="btn btn-icon btn-outline-danger btn-sm"
      @click="$parent.deleteItem(index)"
    >
      <i class="fa-solid fa-trash-can" />
    </button>
  </td>
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-recipe-item";
import moment from "moment";
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.recipe)
  },
  props: {
    recipe: {
      type: Object,
      default: {}
    },
    index: {
      type: Number,
      required: true
    },
    select2ConditionOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    let vm = this;
    return {
    }
  },
  components: {
    Select2
  },
  methods: {
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  async mounted() {},
  computed: {
    totalCost: function() {
      return (this.recipe.quantity_system * this.recipe.cost).toFixed(4);
    },
  },
  watch: {
    totalCost(nval) {
      this.recipe.total_cost = nval;
    }
  }
}
</script>
